import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { StoreContext } from "components/StoreContext";

const Catalog = () => {
  const { categories } = useContext(StoreContext);

  if (categories.tree) {
    return (
      <div className="catalog">
        <div className="catalog__container">
          {categories.tree.map(cat => {
            if (cat.children.length > 0) {
              return (
                <div
                  className="catalog__panel"
                  key={cat.id}
                  data-category-id={cat.text}
                >
                  <div
                    className="catalog__panel-card"
                    onClick={e => e.stopPropagation()}
                    role="presentation"
                  >
                    <Link to={cat.path}>
                      <img src={cat.darkIcon} alt={cat.text} />
                      <h2 className="catalog__panel-title">{cat.text}</h2>
                    </Link>
                    <ul>
                      {cat.children.map(subcat => (
                        <li key={subcat.id}>
                          <Link to={subcat.path}>{subcat.text}</Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              );
            }
            return null;
          })}
          {/*
          <div className="catalog__panel catalog__panel--all">
            <div className="catalog__panel-card">
              <h2 className="catalog__panel-title">
                Not sure what you&apos;re looking for?
              </h2>
              <Link
                className="btn btn-sm btn-block btn-outline-primary"
                to="/catalog"
              >
                Browse entire catalog
              </Link>
            </div>
          </div>
        */}
        </div>
      </div>
    );
  }
  return null;
};

export default Catalog;
